export default __webpack_public_path__ + "static/media/pp.60cba399.htm";